import workspaceQuery from '../../../graphql/queries/product/BinReplenishmentDetailWorkspaceQuery.graphql';
import fragment from '../../../graphql/fragments/product/BinReplenishmentDetailFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';

const BinReplenishmentDetail: EntityType = {
  type: 'BinReplenishmentDetail',
  title: 'Bin Replenishment Details',
  formTitle: 'Bin Replenishment Details',
  workspaceUrl: '/Products/StockControl/ReplenishmentDetail/Workspace/',
  workspace: workspaceQuery,
  fragment,
  screenReference: 'BIN_REPLENISHMENT_DETAIL',
};

export default BinReplenishmentDetail;
